/* =============================================================
   spec-tables-normalize.js

   Cel: tabele zapisane w custom.files_html PRZED erą generatora
   (tools/table-builder.html) nie miały na komórkach class="plain",
   więc na produkcji łapały automatyczne stylowania od colspan/rowspan
   (zielone paski sekcji, light-teal grupy, uppercase, bold). Generator
   już emituje class="plain" — ale legacy HTML zostaje bez klasy.

   Ten skrypt po załadowaniu strony przelatuje wszystkie komórki
   wewnątrz .spec-tables i dokleja class="plain" do każdej, która
   nie ma świadomie wybranej roli (spec-section / spec-rowgroup /
   spec-note). Dzięki temu LEGACY tabele renderują się neutralnie
   (białe tło, normalna waga, brak uppercase, brak letter-spacingu)
   — tak samo jak nowe tabele z generatora.

   No-op dla tabel które już mają class="plain" lub explicit role —
   ten skrypt nigdy nie nadpisuje świadomych decyzji autora.
   ============================================================= */
(function () {
  'use strict';

  var ROLE_CLASSES = ['spec-section', 'spec-rowgroup', 'spec-note', 'plain'];

  function hasRoleClass(cl) {
    for (var i = 0; i < ROLE_CLASSES.length; i++) {
      if (cl.contains(ROLE_CLASSES[i])) return true;
    }
    return false;
  }

  function normalize() {
    var cells = document.querySelectorAll('.spec-tables td, .spec-tables th');
    for (var i = 0; i < cells.length; i++) {
      var cl = cells[i].classList;
      if (hasRoleClass(cl)) continue;
      cl.add('plain');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize);
  } else {
    normalize();
  }
})();